import httpRequest from '@/utils/http'
import { get } from 'jquery'
// 获取导航栏数据
export function getNavListing () {
    return httpRequest({
        url: 'pageListing',  //自己请求的接口
        method: 'get',  //请求方式
    })
}
// 获取首页顶部banner列表
export function getBannerListing (type) {
    return httpRequest({
        url: 'bannerListing?type='+type,  //自己请求的接口
        method: 'get',  //请求方式
    })
}
// 获取首页顶部banner列表手机端
export function getBannerListingMobile (type) {
    return httpRequest({
        url: 'moveBannerListing?type='+type,  //自己请求的接口
        method: 'get',  //请求方式
    })
}
// 内容
export function getDataList (navId) { 
    return httpRequest({
        url: 'pageModuleListing?page_id=' + navId,  //自己请求的接口
        method: 'get',  //请求方式
    })
}
// 企业新闻列表
export function getNewsList (params) { 
    return httpRequest({
        url: 'blogListing?type=' + params.type+'&search='+params.search,  //自己请求的接口
        method: 'get',  //请求方式
    })
}
// 新闻详情
export function getNewsDetail (id) { 
    return httpRequest({
        url: 'blogDetail?id=' + id,  
        method: 'get', 
    })
}

// 问题类型
export function getQuestionType () { 
    return httpRequest({
        url: 'questionTypeListing',  //自己请求的接口
        method: 'get',  //请求方式
    })
}
// 提交问题
export function submitQuestion (data) { 
    return httpRequest({
        url: 'questionAdd',  
        method: 'post',  
        data:data,   
    })
}
// 想要解决的问题选项
export function getSolveOption () { 
    return httpRequest({
        url: 'questionSolveListing', 
        method: 'get',  
    })
}
// 配置说明
export function getConfigInfo (key) { 
    return httpRequest({
        url: 'configInfo?key='+key,  //自己请求的接口
        method: 'get',  //请求方式
    })
}
// 配置 关于我们
export function getConfigInformation () { 
    return httpRequest({
        url: 'configListing',  //自己请求的接口
        method: 'get',  //请求方式
    })
}

export function getPrivacyPolicyList () { 
    return httpRequest({
        url: 'privacyPolicyList',  //自己请求的接口
        method: 'get',  //请求方式
    })
}


export function xxxx(data) {
    return httpRequest({
        url: '',  //自己请求的接口
        method: 'post',  //请求方式
        data:data,    //参数
    })
}